import { Asset } from "../Asset";
export class Polygon extends Asset {
    constructor(vertices, color) {
        super();
        this.vertices = vertices;
        this.color = color;
    }
    draw(ctx, owner) {
        const start = this.vertices.shift();
        ctx.fillStyle = this.color;
        ctx.moveTo(start.getX(), start.getY());
        ctx.beginPath();
        for (let vertex of this.vertices) {
            ctx.lineTo(vertex.getX(), vertex.getY());
        }
        ctx.fill();
    }
}
//# sourceMappingURL=Polygon.js.map